module.exports = __webpack_public_path__ + "img/88.f50ce06a.png";